<template>
  <div>
    <template v-if="conduitClientError !== null">
      <StatusModal
        :mainButtonFunction="returnHome"
        :showModal="conduitClientError !== null"
      >
        <div slot="main-text" class="mx-4" id="application-status-fortiva-error-modal">
          <p>
            <img
              :src="desertPng"
              height="150"
            />
          </p>
          <p class="display-1 mb-4">
            Oops!
          </p>
          <p class="title mb-4" id="application-status-fortiva-error-modal-title">
            We were not able to submit your application at this time
          </p>
          <p v-if="isAddressError()" id="application-status-fortiva-error-modal-address-error">
            Please check the correctness of the Address you provided and try again
          </p>
          <p v-else class="subheading">
            Please contact your contractor or try again
          </p>
        </div>
        <div
          v-if="!easyLinkUser"
          slot="main-button-text"
        >
          OK
        </div>
        <div
          v-else
          slot="main-button-text"
        >
          Close and Clear
        </div>
      </StatusModal>
    </template>

    <template v-else>
      <StatusModal
        v-if='fortivaDeclinedNoPace'
        :companyImage="fortivaSvg"
        :mainButtonFunction="returnHome"
        :showModal="fortivaDeclinedNoPace"
      >
        <div slot="main-text">
          Sorry, no offers available.
        </div>
        <div slot="secondary-text">
          Thank you for applying for a Fortiva Retail Credit Account.
          Unfortunately, your application cannot be approved at this time.
          You will receive an email or letter within the next 30 days with more details.
        </div>
        <span
          slot="main-button-text"
        >
          OK
        </span>
      </StatusModal>
      <StatusModal
        v-else-if="fortivaDeclinedPaceAvailable"
        :companyImage="fortivaSvg"
        :secondaryButtonFunction="returnHome"
        :showModal="fortivaDeclinedPaceAvailable"
      >
        <div slot="main-text">
          Sorry, no offers available.
        </div>
        <div slot="secondary-text">
          Thank you for applying for a Fortiva Retail Credit Account.
          Unfortunately, your application cannot be approved at this time.
          You will receive an email or letter within the next 30 days with more details.
        </div>
      </StatusModal>
      <StatusModal
        v-else-if="fortivaUnderReview"
        :companyImage="fortivaSvg"
        :mainButtonFunction="returnHome"
        :showModal="fortivaUnderReview"
      >
        <div class="mb-5 mt-2" slot="main-text">
          Your Application is currently under review.
          You can call Fortiva Retail Credit directly
          for more information:
        </div>
        <div slot="secondary-text">
          <PhoneLink
            :phoneNumber="'1-866-290-2835'"
          />
        </div>
        <span
          v-if="!easyLinkUser"
          slot="main-button-text"
        >
          OK
        </span>
      </StatusModal>
      <StatusModal
        v-else-if="fortivaExistingCustomer"
        :companyImage="fortivaSvg"
        :mainButtonFunction="returnHome"
        :showModal="fortivaExistingCustomer"
      >
        <div class="mb-5 mt-2" slot="main-text">
          Sorry, it seems like you already have an account with Fortiva.<br/>
          Please, check your email for more information or call:
        </div>
        <div slot="secondary-text">
          <PhoneLink
            :phoneNumber="'800-710-2961'"
          />
        </div>
        <span
          v-if="!easyLinkUser"
          slot="main-button-text"
        >
          OK
        </span>
      </StatusModal>
    </template>
  </div>
</template>

<script>
  import PhoneLink from 'Components/PhoneLink.vue'
  import StatusModal from 'Components/StatusModal.vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'ApplicationStatusFortivaFlow',
    components: {
      PhoneLink,
      StatusModal
    },
    data () {
      return {
        desertPng: require('Assets/empty-desert.png'),
        fortivaSvg: require('Assets/fortiva_logo.svg')
      }
    },
    props: {
      showFan: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        applicationStatus: state => state.loanApplication.applicationStatus,
        conduitClientError: state => state.loanApplication.conduitClientError,
        existingCardHolder: state => state.loanApplication.existingCardHolder,
        lender: state => state.loanApplication.lender,
        paceEligibility: state => state.loanApplication.paceEligibility,
        easyLinkUser: state => state.easyLink.active,
      }),
      fortivaDeclined () {
        return (this.applicationStatus === 'rejected' ||
          this.applicationStatus === 'declined') &&
          this.lender.id === 'fortiva'
      },
      fortivaDeclinedNotExisting () {
        return this.fortivaDeclined &&
          !this.existingCardHolder
      },
      fortivaDeclinedPaceAvailable () {
        return this.fortivaDeclinedNotExisting &&
          this.paceEligibility.eligible
      },
      fortivaDeclinedNoPace () {
        return this.fortivaDeclinedNotExisting &&
          !this.paceEligibility.eligible
      },
      fortivaExistingCustomer () {
        return this.fortivaDeclined &&
          this.existingCardHolder
      },
      fortivaUnderReview () {
        return this.applicationStatus === 'under_review' &&
          this.lender.id === 'fortiva'
      },
    },
    methods: {
      ...mapActions([
        'setLender'
      ]),
      returnHome () {
        this.$emit('returnHome')
      },
      isAddressError () {
          let result = false
          try {
              const err = this.conduitClientError.response.data.errors[0]
              if(err.meta.fields){
                  result = err.meta.fields.contains('applicant.address')
              }
          } catch (e) {
              console.log(e)
          }
        return result
      },
    },
  }
</script>
